import { jsxs as C, jsx as l } from "react/jsx-runtime";
import { useState as c } from "react";
import { CollapseContainer as d, CollpaseContent as f, CollapseButton as m } from "./style.js";
const j = ({
  children: a,
  className: n,
  openCollapseText: s,
  closeCollapseText: i,
  onOpen: e,
  onClose: o,
  ...r
}) => {
  const [t, p] = c(!1);
  return /* @__PURE__ */ C(d, { className: n, ...r, children: [
    /* @__PURE__ */ l(f, { "data-testid": "content-wrapper", "aria-hidden": !t, children: a }),
    /* @__PURE__ */ l(
      m,
      {
        "aria-expanded": t,
        type: "button",
        onClick: () => {
          !t && e && e(), t && o && o(), p(!t);
        },
        children: t ? i : s
      }
    )
  ] });
};
export {
  j as Collapse
};
